import React from 'react';

import {
    AbilityLookup,
    Action,
    CharacterTheme,
    CharacterUtils,
    DataOriginRefData,
    Feat,
    FeatUtils,
    RuleData,
    SnippetData,
    SourceMappingContract,
    Spell,
} from '@dndbeyond/character-rules-engine/es';

import FeatureSnippet from '../FeatureSnippet';

interface Props {
    feat: Feat;
    feats: Array<Feat>;
    extraMeta: Array<string>;
    onActionClick?: (action: Action) => void;
    onActionUseSet?: (action: Action, uses: number) => void;
    onSpellClick?: (spell: Spell) => void;
    onSpellUseSet?: (spell: Spell, uses: number) => void;
    onFeatureClick?: (feat: Feat) => void;

    showHeader?: boolean;
    showDescription?: boolean;

    snippetData: SnippetData;
    ruleData: RuleData;
    abilityLookup: AbilityLookup;
    dataOriginRefData: DataOriginRefData;
    isReadonly: boolean;
    proficiencyBonus: number;
    theme: CharacterTheme;
}
export default class FeatFeatureSnippet extends React.PureComponent<Props> {
    static defaultProps = {
        extraMeta: [],
        showDescription: false,
    };

    handleFeatureClick = (): void => {
        const { feat, onFeatureClick } = this.props;

        if (onFeatureClick) {
            onFeatureClick(feat);
        }
    };

    render() {
        const { feat, onFeatureClick, showDescription, ...restProps } = this.props;

        let sourceId: number | null = null;
        let sourcePage: number | null = null;
        let filteredSources = FeatUtils.getSources(feat).filter(CharacterUtils.isPrimarySource);
        if (filteredSources.length) {
            let primarySource: SourceMappingContract = filteredSources[0];
            sourceId = primarySource.sourceId;
            sourcePage = primarySource.pageNumber;
        }

        return (
            <FeatureSnippet
                {...restProps}
                heading={FeatUtils.getName(feat)}
                className="ct-feature-snippet--feat"
                actions={FeatUtils.getActions(feat)}
                options={FeatUtils.getOptions(feat)}
                choices={FeatUtils.getChoices(feat)}
                spells={FeatUtils.getSpells(feat)}
                sourceId={sourceId}
                sourcePage={sourcePage}
                onFeatureClick={this.handleFeatureClick}
                showDescription={showDescription}
            >
                {showDescription ? FeatUtils.getDescription(feat) : FeatUtils.getSnippet(feat)}
            </FeatureSnippet>
        );
    }
}
